

// Lazy-loaded components for code splitting
const ReportsLibPage = () => import(/* webpackChunkName: "reports" */ "./ReportsLibPage.vue");
export default [
    {
        path: "/reports/:reportName",
        component: ReportsLibPage,
        name: "reports",
    },
];
